var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1901_369)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.90635 4.375C3.90635 3.42188 4.28498 2.50779 4.95894 1.83383C5.63289 1.15988 6.54698 0.78125 7.5001 0.78125C8.45322 0.78125 9.36731 1.15988 10.0413 1.83383C10.7152 2.50779 11.0939 3.42188 11.0939 4.375C11.0939 5.32812 10.7152 6.24221 10.0413 6.91616C9.36731 7.59012 8.45322 7.96875 7.5001 7.96875C6.54698 7.96875 5.63289 7.59012 4.95894 6.91616C4.28498 6.24221 3.90635 5.32812 3.90635 4.375ZM7.37323 8.91312C7.40006 8.90849 7.42725 8.90619 7.45448 8.90625H7.54448C7.57198 8.90625 7.59948 8.90875 7.62635 8.91312L12.1857 9.715C12.1937 9.71642 12.2016 9.71809 12.2095 9.72C13.0489 9.91375 13.9514 10.4469 14.127 11.4825C14.1281 11.4885 14.1292 11.4946 14.1301 11.5006L14.2007 12.0487V12.05C14.3664 13.3056 13.3707 14.2187 12.1945 14.2187C12.1687 14.2188 12.143 14.2167 12.1176 14.2125H2.8051C1.62885 14.2125 0.633226 13.2987 0.798851 12.0425L0.870101 11.4994C0.871017 11.4931 0.872059 11.4869 0.873226 11.4806C1.04823 10.4637 1.9576 9.90062 2.79635 9.71875C2.80237 9.71737 2.80841 9.71612 2.81448 9.715L7.37323 8.91312Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1901_369"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.bfaba4e57bdb3b7a64f88e25cce86e52.svg";
export { ForwardRef as ReactComponent };